import { tViews } from "../../../../../utils/table";
import { BASE_URL } from "../../../../../apis/apiConstants";

export default {
  get title() { return tViews('tableHeadingTopApp'); },
  get subTitle() { return tViews('appViewApplication'); },
  columns: [
    {
      get title() { return tViews('appViewApplication'); },
      colSpan: 1,
      property: "application",
      type: "string",
      format: "link",
      maxLength: 15,
      path: `${BASE_URL}/Dashboards`
    },
    {
      get title() { return tViews('appViewByQoE'); },
      colSpan: 1,
      property: "vqoe_score",
      type: "number",
      theme: "change",
      tooltip: true,
      get tooltipTitle() { return tViews('appQoeTooltipTitle'); },
      get tooltipDefinition() { return tViews('appQoeTooltipDefinition'); },
      padding: "5px"
    },
    {
      title: null,
      colSpan: 1,
      property: "distributionTotal",
      type: "number",
      tooltip: false,
      get tooltipTitle() { return tViews('appQoeTooltipTitle'); },
      get tooltipDefinition() { return tViews('appQoeTooltipDefinition'); },
      padding: "2px"
    },
    {
      title: null,
      colSpan: 1,
      property: "chart",
      type: "chart",
      format: "stackedBarChart",
      width: "50%"
    }
  ]
};
